<!--
Displays a wait/loading spinner.
Usage:
  HTML:
    <Spinner ref="spinner" />
  JavaScript:
    this.$refs.spinner.spin()
    this.$refs.spinner.stop()
@author bmk11u
-->
<template>
  <div id="spinner" class="text-center pl-5 pr-5" v-if="show">
    <div class="alert alert-light border">
      <div class="spinner-grow text-info" role="status"></div>
      <div>Please wait...</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  methods: {
    spin () {
      this.show = true
    },
    stop () {
      this.show = false
    }
  },
  data () {
    return {
      show: false
    }
  }
}
</script>

<style scoped lang="scss">
#spinner {
  position:absolute;
  top: 40%;
  left:1%;
  right:1%;
  margin-left:auto;
  margin-right:auto;
  z-index: 2000;
  width: 60%;
 }
</style>
